<template>

  <section class="popup__content container" id="popup__content">

    <div class="popup__content__hero-wrap" id="popup__content-scroller">
      <noscript is="lazy-element" class="lazy-element ratio-wide popup__content__hero">
        <img :alt="artist.artist_name" :src="artist.artist_pic">
      </noscript>
    </div>

    <div class="popup__content__row row pt-3">
      <div class="col-12 col-md-6 pb-5">
        <h2>{{artist.artist_name}}</h2>
        <p v-html="artist.artist_bio"></p>
        <p v-if="artist.alternative_booking_mail" class="mail">
            {{artist.alternative_booking_text}}:<br>
            <i class="icon-mail text-nowrap"><span>{{reversedAltEmail}}</span></i>
        </p>
        <p class="mail">
          {{page.booking_text_artistpage}}:<br>
          <i class="icon-mail text-nowrap"><span>{{reversedEmail}}</span></i>
        </p>
      </div>

      <div class="col-12 offset-lg-1 col-md-6 col-lg-5 pb-5">
        <div class="sm-wrap">
          <a
            v-for="sm in artist.artist_social_media"
            target="_blank"
            :href="sm.link"
            :class="'pb-1 sm-icon icon-'+(sm.platform).replace(/\s+/g, '-').toLowerCase()+' text-big'">
          </a>
        </div>
        <!--<h4 v-if="artist.mix && $parent.cookies">Listen</h4>-->
        <div class="pt-2" v-if="artist.mix && $parent.cookies" v-html="artist.mix">
        </div>
        <!--<h4 v-if="$parent.cookies && this.artist.artist_facebook_events">Dates</h4>-->
        <div v-if="$parent.cookies && this.artist.artist_facebook_events" class="fb-wrap pt-2">
          <div class="fb-page" :data-href="this.artist.artist_facebook_events" data-tabs="events" data-width="500" data-height="400" data-small-header="true" data-adapt-container-width="true" data-hide-cover="true" data-show-facepile="false"></div>
        </div>
      </div>

      <div class="col-12 pb-5" v-if="artist.artist_video && $parent.cookies">
        <div class="embed-responsive ratio-normal" v-html="artist.artist_video"></div>
      </div>

      <nav class="col-12 pb-5">
        <div class="row">
          <div class="col-6">
            <button @click="previous()" title="previous artist" class="btn btn--secondary btn--secondary--dark btn--previous">
              <span class="icon-angle-left"></span>
              {{prevArtist}}
            </button>
          </div>
          <div class="col-6">
            <button @click="next()" title="next artist" class="btn btn--secondary btn--secondary--dark btn--next">
              {{nextArtist}}
              <span class="icon-angle-right"></span>
            </button>
          </div>
        </div>
      </nav>
    </div>

  </section>

</template>

<script>
  import LazyElement from '../components/LazyElement.vue';
  import router from 'vue-router';

  export default {
    name: 'Artist',
    props: ['page'],
    components: {
      LazyElement
    },
    data: function () {
      return {
        artist: {},
        prevArtist: '',
        nextArtist: '',
      }
    },
    watch: {
      $route() {
        this.getArtist();
      }
    },
    computed: {
      reversedEmail(){
        return this.page.booking_email.split('').reverse().join('')
      },
      reversedAltEmail(){
        return this.artist.alternative_booking_mail.split('').reverse().join('')
      }
    },
    methods: {
      init() {
        this.disableScrolling();
        this.inert();
        this.getArtist();
      },
      scroll() {
        let scrollChild = document.getElementById('popup__content-scroller');
        let topPos = scrollChild.offsetTop;
        document.getElementById('popup__content').scrollTop = topPos;
      },
      async deactivate() {
        this.enableScrolling();
        await this.inert(false);
      },
      disableScrolling() {
        this.scrollPosition = window.pageYOffset;
        const $body = document.querySelector('body');
        $body.style.overflow = 'hidden';
        $body.style.position = 'fixed';
        $body.style.top = `-${this.scrollPosition}px`;
        $body.style.width = '100%';
      },
      enableScrolling() {
        const $body = document.querySelector('body');
        $body.style.removeProperty('overflow');
        $body.style.removeProperty('position');
        $body.style.removeProperty('top');
        $body.style.removeProperty('width');
        $body.scrollTop =  this.scrollPosition;
      },
      async inert(status = true) {
        await this.$nextTick();
        [...this.$root.$el.children].forEach((child) => {
          if (child === this.$el || child.contains(this.$el)) return;
          child.inert = status;
        });
      },
      getArtist: function() {
        let that = this;
        this.page.artists.forEach(function(artist, index){
          if (artist.artist_name.replace(/\s+/g, '-').toLowerCase() === that.$route.params.id) {
            that.artist = artist;
            if (index > 0) {
              that.prevArtist = that.page.artists[index - 1].artist_name;
            } else {
              that.prevArtist = that.page.artists[that.page.artists.length - 1].artist_name;
            }
            if (index < that.page.artists.length - 1) {
              that.nextArtist = that.page.artists[index + 1].artist_name;
            } else {
              that.nextArtist = that.page.artists[0].artist_name;
            }
          }
        });
        setTimeout(function(){
          FB.XFBML.parse();
        },100);
      },
      previous: function() {
        let _this = this;
        this.$router.push({ name: 'Artist', params: { id: this.prevArtist.replace(/\s+/g, '-').toLowerCase() } });
        setTimeout(function(){
          _this.scroll();
        },150);
      },
      next: function() {
        let _this = this;
        this.$router.push({ name: 'Artist', params: { id: this.nextArtist.replace(/\s+/g, '-').toLowerCase() } });
        setTimeout(function(){
          _this.scroll();
        },150);
      }
    },
    mounted() {
      const close = (e) => {
        const ESC = 27;
        if (e.keyCode !== ESC) return;
        this.$emit('close');
      };
      document.addEventListener('keyup', close);
      this.$on('hook:destroyed', () => {
        document.removeEventListener('keyup', close);
      });
      this.$on('hook:destroyed', () => {
        this.deactivate();
      });
      this.init();
    }
  }
</script>

<style>

</style>
